var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSrkApartIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6.25V20H20V6.25H16.25V16.25L11.25 13.75L6.25 16.25V6.25H2.5ZM2.5 22.5C1.8125 22.5 1.22396 22.2552 0.734375 21.7656C0.244792 21.276 0 20.6875 0 20V4.40625C0 4.11458 0.046875 3.83333 0.140625 3.5625C0.234375 3.29167 0.375 3.04167 0.5625 2.8125L2.125 0.90625C2.35417 0.614583 2.64062 0.390625 2.98438 0.234375C3.32812 0.078125 3.6875 0 4.0625 0H18.4375C18.8125 0 19.1719 0.078125 19.5156 0.234375C19.8594 0.390625 20.1458 0.614583 20.375 0.90625L21.9375 2.8125C22.125 3.04167 22.2656 3.29167 22.3594 3.5625C22.4531 3.83333 22.5 4.11458 22.5 4.40625V20C22.5 20.6875 22.2552 21.276 21.7656 21.7656C21.276 22.2552 20.6875 22.5 20 22.5H2.5ZM3 3.75H19.5L18.4375 2.5H4.0625L3 3.75ZM8.75 6.25V12.1875L11.25 10.9375L13.75 12.1875V6.25H8.75ZM2.5 6.25H6.25H11.25H16.25H20H2.5Z",
    fill: "#1D3B5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrkApartIcon1);
export default __webpack_public_path__ + "static/media/srk-apart-icon1.a87a33da3fc6458a657ec48dfa2a1ac7.svg";
export { ForwardRef as ReactComponent };